import React from 'react';
import { Message } from '../../types';
import { getInitials, getAvatarColor } from '../../utils/avatarUtils';

interface ChatMessageProps {
  message: Message;
  userName?: string;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message, userName }) => (
  <div className={message.role === 'user' ? "mb-6" : "mb-2"}>
    <div className={`flex ${message.role === 'user' ? 'justify-end' : 'justify-start'}`}>
      {message.role === 'assistant' && (
        <div 
          className="w-12 h-12 rounded-full mr-2 flex-shrink-0 self-end"
          style={{
            background: `
              radial-gradient(circle at 30% 30%, #01BCD4 0%, transparent 50%),
              radial-gradient(circle at 70% 60%, #8433ff 0%, transparent 50%),
              radial-gradient(circle at 40% 80%, white 0%, transparent 50%),
              #f0f0f0
            `,
            backgroundSize: '100% 100%'
          }}
        />
      )}
      <div 
        className={`${
          message.itemId === 'system-topic-message' 
            ? 'bg-yellow-100 text-yellow-800 italic rounded-lg px-3 py-2' 
            : ''
        }`}
        style={{
          maxWidth: '60%',
          backgroundColor: message.itemId !== 'system-topic-message' 
            ? (message.role === 'user' ? '#111C27' : '#F6F3F1')
            : undefined,
          color: message.itemId !== 'system-topic-message'
            ? (message.role === 'user' ? 'white' : '#121D28')
            : undefined,
          paddingLeft: message.itemId !== 'system-topic-message' ? '20px' : undefined,
          paddingRight: message.itemId !== 'system-topic-message' ? '20px' : undefined,
          paddingTop: message.itemId !== 'system-topic-message' ? '16px' : undefined,
          paddingBottom: message.itemId !== 'system-topic-message' ? '16px' : undefined,
          fontSize: message.itemId !== 'system-topic-message' ? '16px' : undefined,
          fontFamily: message.itemId !== 'system-topic-message' ? 'Lato' : undefined,
          fontWeight: message.itemId !== 'system-topic-message' ? '600' : undefined,
          lineHeight: message.itemId !== 'system-topic-message' ? '24px' : undefined,
          wordWrap: 'break-word',
          borderTopLeftRadius: message.itemId !== 'system-topic-message' ? '20px' : undefined,
          borderTopRightRadius: message.itemId !== 'system-topic-message' ? '20px' : undefined,
          borderBottomLeftRadius: message.itemId !== 'system-topic-message' && message.role === 'user' ? '20px' : '4px',
          borderBottomRightRadius: message.itemId !== 'system-topic-message' && message.role === 'assistant' ? '20px' : '4px'
        }}
      >
        {message.text}
      </div>
      {message.role === 'user' && (
        <div 
          className="w-12 h-12 rounded-full ml-2 flex-shrink-0 self-end flex items-center justify-center text-white font-bold text-lg"
          style={{
            backgroundColor: getAvatarColor(userName),
            fontSize: '18px',
            fontFamily: 'Lato, sans-serif'
          }}
        >
          {getInitials(userName)}
        </div>
      )}
    </div>
    {message.role === 'assistant' && message.itemId !== 'system-topic-message' && (
      <div className="flex gap-3 mt-2 ml-14">
        <button 
          className="w-9 h-9 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition-colors"
        >
          <img 
            src="/Icon/volume_up.svg" 
            alt="Listen" 
            className="w-5 h-5"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.onerror = null;
              target.style.display = 'none';
            }}
          />
        </button>
        <button 
          className="w-9 h-9 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition-colors"
        >
          <img 
            src="/Icon/Translate.svg" 
            alt="Translate" 
            className="w-5 h-5"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.onerror = null;
              target.style.display = 'none';
            }}
          />
        </button>
        <button 
          className="w-9 h-9 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition-colors"
        >
          <img 
            src="/Icon/turtle_1.svg" 
            alt="Slow down" 
            className="w-5 h-5"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.onerror = null;
              target.style.display = 'none';
            }}
          />
        </button>
      </div>
    )}
  </div>
);

export default ChatMessage;
